namespace Areas.Analysis.Building {
    "use strict";

    export function goToBuildingFromGrid(e: any) {
        const dataGrid = $("#BuildingsGrid").dxDataGrid("instance");
        const rows = dataGrid.getSelectedRowsData();
        if (rows.length == 1) {
            location.href = "/Building/Profile/View/" + rows[0].buildingId;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function columnViewLink(cellElement: any, cellInfo: any) {
        let linkInfo = "<a href= '/Building/Profile/View/{placeholder}'>View</a>";

        buildCellContent(cellElement,
            () => { return cellInfo.data.buildingId; },
            linkInfo);
    }
}